// Definition
export const PRIMARY_COLOR = '#10CBA5';
export const PRIMARY_COLOR_ACTIVE = '#40D5B7';
export const PRIMARY_COLOR_HOVER = '#0DA284';

export const SECONDARY_COLOR = '#000000'
export const SECONDARY_COLOR_1 = '#52565C';
export const SECONDARY_COLOR_2 = '#A0A3A8';
export const SECONDARY_COLOR_3 = '#CACCCF';
export const SECONDARY_COLOR_4 = '#E1E2E3';
export const SECONDARY_COLOR_5 = '#E8E8E8';
export const SECONDARY_COLOR_6 = '#F2F4F7';

export const SUCCESS_COLOR = PRIMARY_COLOR;
export const FAIL_COLOR = '#FF5C5C';

// Sidebar
export const SIDEBAR_ITEM_ICON_COLOR = SECONDARY_COLOR_2;
export const SIDEBAR_ITEM_ICON_COLOR_ACTIVE = PRIMARY_COLOR;
export const SIDEBAR_ITEM_ICON_COLOR_HOVER = SECONDARY_COLOR;
export const SIDEBAR_ITEM_TEXT_COLOR_ACTIVE = SECONDARY_COLOR;

// Tabs
export const TABS_TEXT_COLOR = SECONDARY_COLOR_2;
export const TABS_TEXT_COLOR_ACTIVE = SECONDARY_COLOR_2;
export const TABS_UNDERLINE_COLOR = PRIMARY_COLOR;

// Dark Theme
export const START_PAGE_COLOR_DARK = '#000';
